import type { HTMLAttributes, ReactElement } from 'react';

import { cn } from '../lib/cn.js';

export const Card = ({ className, ...props }: HTMLAttributes<HTMLDivElement>): ReactElement => (
  <div
    className={cn(
      'rounded-(--radius-card) border border-border-subtle bg-surface-1 text-text-primary',
      className,
    )}
    {...props}
  />
);

export const CardHeader = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): ReactElement => (
  <div className={cn('flex flex-col space-y-1.5 p-4', className)} {...props} />
);

export const CardTitle = ({
  className,
  ...props
}: HTMLAttributes<HTMLHeadingElement>): ReactElement => (
  <h3 className={cn('text-xl font-semibold leading-none tracking-tight', className)} {...props} />
);

export const CardDescription = ({
  className,
  ...props
}: HTMLAttributes<HTMLParagraphElement>): ReactElement => (
  <p className={cn('text-sm text-text-secondary', className)} {...props} />
);

export const CardContent = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): ReactElement => (
  <div className={cn('p-4 pt-0', className)} {...props} />
);

export const CardFooter = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): ReactElement => (
  <div className={cn('flex items-center p-4 pt-0', className)} {...props} />
);
